import WordsearchCell from '../models/WordsearchCell'
import api from '@puzzleapps/shared/src/utils/api'

import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/grid'

// TODO: Make cells array one dimensional
const state = {
    ...baseState,
}

const getters = {
    ...baseGetters,
}

const actions = {
    ...baseActions,

    fetchPuzzle({ commit, dispatch, rootState, state }) {
        commit('SET_LOADED', false)            
        commit('SET_SELECTED_CELL', null)            

        return new Promise((resolve, reject) => {

            let puzzleId = rootState.game.puzzleId
            if (!puzzleId) throw new Error('Puzzle id must be specified.')
    
            api.data(puzzleId)
                .then(data => {
                    if (process.env.NODE_ENV === 'development') {
                        console.log('api.data', data)
                    }
                    commit('SET_WORDSEARCH_GRID', data)
                    dispatch('wordlist/setTitle', data.t, {root: true})
                    dispatch('wordlist/setSolution', data.s, {root: true})
                    dispatch('wordlist/setWords', data.w, {root: true})
                    dispatch('loadUserDataFromLocal', puzzleId)
                    commit('SET_LOADED', true)
                    resolve(data)
                })
        })
    },

    // payload = {row, col, input}
    setInputAtPos({ commit, dispatch, state, rootState, getters }, payload) {
        if (!payload) 
            throw new Error('Cell row and payload required. Given: ' + payload)

        let cell = state.cells[payload.row][payload.col]

        if (cell.input == payload.input) return

        if (!payload.isUndo) 
        {
            dispatch('undoRedo/clearRedoHistory', null, { root: true })
            dispatch('undoRedo/pushHistory', {
                row: payload.row,
                col: payload.col,
                input: cell.input,
            }, { root: true })
        }

        if (payload.input !== 0) cell.refreshMarks()
    
        commit('SET_USER_INPUT_AT_POS', payload)
        dispatch('checkCompleted')
    },

    highlightLetter({ commit, dispatch, state, rootState }, letter){
        let cells = state.cells
        
        
        for(let i = 0; i < cells.length; i++)
        {
            for(let j = 0; j < cells[i].length; j++){
                    let p = {
                        row: i,
                        col: j,
                        selected: cells[i][j].letter === letter ? true : false,
                    }
                    
                    commit('SET_HIGHLIGHTED_CELL',p)
                    
            }
        }
        dispatch('wordlist/letterHint', false, {root: true})

    },

    unhighlightAll({ commit, state, dispatch, rootState }){
        //let cells = rootState.grid.cells
        let cells = state.cells
        
        for(let i = 0; i < cells.length; i++)
        {
            for(let j = 0; j < cells[i].length; j++){
              if(cells[i][j].selected === true){
                let p = {
                  row: i,
                  col: j,
                  selected: false,
              }
              
              commit('SET_HIGHLIGHTED_CELL',p)
    
              }
                    
                    
            }
        }
      },

    // loadWordSearchDataFromLocal({ commit, state }, puzzleId) {
    //     let stored = localStorage.getItem(`puzzle-${ puzzleId }`)

    //     if (!stored || stored === 'undefined') return

    //     stored = JSON.parse(stored)
        
    //     for (let i = 0; i < state.rows; i++) 
    //     {
    //         for (let j = 0; j < state.cols; j++) 
    //         {
    //             let cell = state.cells[i][j]
                
    //             commit('SET_USER_INPUT_AT_POS', {
    //                 row: cell.row, 
    //                 col: cell.col, 
    //                 input: stored.inputs[0],
    //             })
    //             stored.inputs.shift()
    //         }
    //     }
    // },

}

const mutations = {
    ...baseMutations,

    // example json data
    // {"r":15,
    // "c":15,
    // "g": "REVLONROCIRPACCCMOOLBODNALROHAAREMACHSURCEULBRJUDITHNAMREPUSEMPNEWCOMERSIEDEOYANACTRESSLNARETLAUTCELLETNIQEURLILAHCGUEELNNAESEHTDNOYEBYSIEDIEEDARDNASPELBNOSESSORCALLSESOLNOTECNIRPARPTWTLRAMERICANOIAIAREETNULOVEHPCNNOTLIMAHDAT",
    // "s": "CHAMPION EQUESTRIAN"
    // "t": "KATE BOSWORTH"
    // w: [
        // {r: 8, c: 13, w: "BEYOND THE SEA", d: 6}
        // {r: 6, c: 14, w: "INTELLECTUAL", d: 6}
        // {r: 1, c: 12, w: "ORLANDO BLOOM", d: 6}
        // ....
        // ]
    // }
    SET_WORDSEARCH_GRID(state, json) {
        state.cols = json.c
        state.rows = json.r

        // create empty cells
        let cells = []
        let lettersArr = json.g.split('')

        for (let i = 0; i < state.rows; i++) 
        {
            let row = []

            for (let j = 0; j < state.cols; j++) 
            {
                let index = state.cols * i  + j

                let cell = new WordsearchCell()                
                cell.row = i
                cell.col = j
                cell.letter = lettersArr[index]

                row.push(cell)
            }

            cells.push(row)
        }

        state.cells = cells
    },
    SET_HIGHLIGHTED_CELL(state, p){
        let cell = state.cells[p.row][p.col]
        cell.selected = p.selected
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}